// @ts-nocheck
import { Record, RepeatableItemValue } from '@fulcrumapp/fulcrum-core';

export default class FeatureEditState {
  constructor(feature) {
    this.formValues = feature.formValues.copy();
    this.latitude = feature.latitude;
    this.longitude = feature.longitude;
    this.geometry = feature.geometry;
    this.createdDuration = feature.createdDuration;
    this.updatedDuration = feature.updatedDuration;
    this.editedDuration = feature.editedDuration;

    if (feature instanceof Record) {
      this.status = feature.status;
      this.createdAt = feature.clientCreatedAt;
      this.updatedAt = feature.clientUpdatedAt;

      if (feature.projectID) {
        this.projectID = feature.projectID;
        this.projectName = feature.projectName;
      }

      if (feature.assignedToID) {
        this.assignedToID = feature.assignedToID;
        this.assignedToName = feature.assignedToName;
      }
    } else if (feature instanceof RepeatableItemValue) {
      this.createdAt = feature.createdAt;
      this.updatedAt = feature.updatedAt;
    }
  }

  isEqual(object) {
    if (!(object instanceof FeatureEditState)) {
      return false;
    }

    if (object === this) {
      return true;
    }

    const statusEqual = (this.status === object.status);
    const projectEqual = (this.projectID === object.projectID);
    const assignmentEqual = (this.assignedToID === object.assignedToID);

    let valuesEqual = false;

    if (this.formValues == null || object.formValues == null) {
      valuesEqual = this.formValues == null && object.formValues == null;
    } else {
      const thisJSON = this.formValues.toJSON();
      const thatJSON = object.formValues.toJSON();

      if (thisJSON == null || thatJSON == null) {
        valuesEqual = thisJSON == null && thatJSON == null;
      } else {
        valuesEqual = JSON.stringify(thisJSON) === JSON.stringify(thatJSON);
      }
    }

    const coordinateEqual = (this.latitude === object.latitude
                             && this.longitude === object.longitude);

    const geometryEqual = (this.geometry === object.geometry);

    return valuesEqual
      && statusEqual
      && projectEqual
      && assignmentEqual
      && coordinateEqual
      && geometryEqual;
  }

  restore(feature) {
    if (feature instanceof Record) {
      this.restoreRecord(feature);
    } else if (feature instanceof RepeatableItemValue) {
      this.restoreRepeatable(feature);
    }
  }

  restoreRecord(record) {
    record.clientCreatedAt = this.createdAt;
    record.clientUpdatedAt = this.updatedAt;
    record._formValues = this.formValues.copy();
    record.projectID = this.projectID;
    record._projectName = this.projectName;
    // TODO(zhm) fix this
    record.assignedToID = this.assignedToID;
    record._assignedToName = this.assignedToName;
    record.status = this.status;
    record.latitude = this.latitude;
    record.longitude = this.longitude;
    record.geometry = this.geometry;
    record.createdDuration = this.createdDuration;
    record.updatedDuration = this.updatedDuration;
    record.editedDuration = this.editedDuration;
  }

  restoreRepeatable(record) {
    record.createdAt = this.createdAt;
    record.updatedAt = this.updatedAt;
    record._formValues = this.formValues.copy();
    record.latitude = this.latitude;
    record.longitude = this.longitude;
    record.geometry = this.geometry;
    record.createdDuration = this.createdDuration;
    record.updatedDuration = this.updatedDuration;
    record.editedDuration = this.editedDuration;
  }
}
